import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

export const selectedCategoryAtomFamily = atomFamily((key) => atom(""));
